import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { SearchIcon } from 'src/assets/icons/SearchIcon';

export const HeaderWrapper = styled('div', { label: 'HeaderWrapper' })`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin: 0 0 16px 0;
`;

export const SearchInputWrapper = styled('div', { label: 'SearchInputWrapper' })`
    height: 32px;
    width: 240px;
    position: relative;
`;

export const SearchInput = styled('input', { label: 'SearchInput' })`
    border: 1px solid #edf2fa;
    border-radius: 4px;
    height: 100%;
    width: 100%;
    color: ${mainColors.grays.gray400};
    padding-left: 27px;

    &[type=number]::-webkit-inner-spin-button,
    &[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const BlockTitle = styled('h3', { label: 'BlockTitle' })`
    font-size: 18px;
    font-weight: 700;
    color: ${mainColors.main.primary};
    margin: auto 0;
`;

export const SearchIconWrapper = styled(SearchIcon, { label: 'SearchIconWrapper' })`
    position: absolute;
    top: 0;
    bottom: 0;
    fill: ${mainColors.grays.gray400};
    margin: auto 0 auto 9px;
`;
